import { HttpErrorResponse, HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { DipRegistrationCustomerIdentityResponse } from 'src/app/dip-registration-customer-identification/models/dip-registration-customer-identity-response.model';
import { LoggerBackEndCallEventContent, LoggerEventEnum } from '../models/dip-registration-log-information.model';
import { DipRegistrationLoggingNames } from '../enum/dip-registration-logging-names.enum';
import { Router } from '@angular/router';
import { DipRegistrationErrorsHandler } from '../../dip-registration-error/dip-registration-errors.handler';
import { LoaderService } from '../../shared/components/loader/loader.service';
import { DipRegistrationService } from '../../dip-registration.service';
import { DiprsSpaLoggerService } from './logger/diprs-spa-logger.service';
import { DipCustomerIdentity } from 'src/app/dip-registration-customer-identification/models/dip-registration-customer-identity.model';
import {WebMetricsService} from './web-metrics/web-metrics.service';
import {WebMetricStore} from './stores/dip-web-metric-store.service';
import { DipRegistrationContextService } from './dip-registration-context.service';


@Injectable()
export class DipRegistrationCustomerIdentityService {

    constructor(
        private router: Router,
        private errorHandler: DipRegistrationErrorsHandler,
        private dipseLoaderService: LoaderService,
        private dipRegistrationService: DipRegistrationService,
        private spaLoggerService: DiprsSpaLoggerService,
        private webMetricsService: WebMetricsService,
        private dipRegistrationContextService: DipRegistrationContextService,
        private webMetricStore: WebMetricStore
      ) {
      }

    async create(customerIdentity: DipCustomerIdentity | {dipssGuid: string}) {
        if (customerIdentity['dipssGuid']) {
          this.dipRegistrationContextService.setIsAutoEnrollFlow(true);
        }
        let start: number;
        let end: number;
        let result: HttpResponse<DipRegistrationCustomerIdentityResponse> | HttpErrorResponse = null;
        let errorInfo: any = {};
        try {
            this.dipseLoaderService.show();
            start = performance.now();
            const [customerIdentityResponse, ignore]: HttpResponse<DipRegistrationCustomerIdentityResponse> | any = await Promise.all([this.dipRegistrationService.sendCustomerIdentity(customerIdentity),
             this.dipseLoaderService.hideIn(2000)]);
            end = performance.now();
            result = customerIdentityResponse;
            if (customerIdentityResponse.body) {
              const launchFrom = this.getLauchFrom(customerIdentityResponse.body.channelType);
              this.webMetricStore.setLaunchFrom(launchFrom);
              await this.router.navigate(['phone-number-list']);
            }
          } catch (err) {
            end = performance.now();
            let message = err;
            if (err instanceof HttpErrorResponse) {
              message = err.message;
              result = err;
            }
            errorInfo = this.errorHandler.getErrorCodeAndMessage(err.error);
            this.spaLoggerService.error(LoggerEventEnum.FUNCTIONAL_ERROR, DipRegistrationLoggingNames.CUSTOMER_IDENTIFICATION, { description: message, userFeedbackMessage: 'Error Code: ' + errorInfo.errorCode});
            await this.dipseLoaderService.hideIn(2000);
            window.scrollTo(0, 0);
            await this.errorHandler.handleError(err);
          } finally {
            const eventAdditionalInfo: LoggerBackEndCallEventContent = {
              backEndUrl: result.url,
              httpMethod: 'POST',
              httpStatusCode: result.status,
              executionTime: Math.round(end - start),
              errorCode: errorInfo.errorCode,
              backEndEndpoint: result.url.split('/').pop()
            };
            this.dipRegistrationContextService.setIsAutoEnrollFlow(false);
            this.spaLoggerService.info(LoggerEventEnum.BACKEND_CALL, DipRegistrationLoggingNames.CUSTOMER_IDENTIFICATION, eventAdditionalInfo);
        }
    }

  private getLauchFrom(channelType: string): string {
    switch (channelType) {
      case 'BOL' :
        return 'bol';
      case 'GWPC' :
        return 'phone-agent-email';
      default :
        return 'public-site';
    }
  }
}
